import LoginForm from './login-form';
import RegisterContent, { SMS_KEY } from '../../register/register-content';
import Modal from '../../shared/modals/modal';

export type AUTH_STATE = 'LOGIN' | 'REGISTER' | 'DONE';

export type MahakModalPropsType = {
  showModal: boolean;
  mobile: string;
  state: AUTH_STATE;
  onSuccess: () => void;
  onClose: () => void;
};

function MahakModal({ state, mobile, showModal, onSuccess, onClose }: MahakModalPropsType) {
  if (!showModal) return null;

  function getContent() {
    switch (state) {
      case 'LOGIN':
        return (
          <div className='mt-6'>
            <LoginForm mobile={mobile} onSuccess={onSuccess} />
          </div>
        );
      case 'REGISTER':
        return (
          <div className='mt-6'>
            <RegisterContent
              noLabel
              startStep={SMS_KEY}
              defaultMobile={mobile}
              onSuccess={onSuccess}
              onCancel={onClose}
            />
          </div>
        );
      case 'DONE':
        return (
          <div className='mx-2 mt-1'>
            <p>ثبت‌نام شما در آزمون محک آذر ماه با موفقیت انجام شد.</p>
            <p>
              <span>این آزمون در تاریخ </span>
              <span className='font-bold'>30 آذر ماه</span>
              <span> در سامانه آزمون فعال خواهد شد.</span>
            </p>
          </div>
        );
    }
  }

  return (
    <Modal showCloseButton showModal={showModal} onClose={onClose}>
      {getContent()}
    </Modal>
  );
}

export default MahakModal;
